/**
 * Auditoría: bitácora inmutable de todo cambio de estado relevante (§15).
 * Reemplaza el `togglePayoutStatus` sin rastro del HTML (defecto F8).
 */
import { z } from 'zod';
import { RoleSchema } from '../roles.js';

export const AuditActionSchema = z.enum([
  'fight.created',
  'fight.updated',
  'fight.locked',
  'fight.settled',
  'fight.cancelled',
  'bet.created',
  'bet.paid',
  'bet.voided',
  'payout.settled_all',
  'preset.created',
  'preset.updated',
  'preset.status_changed',
  'user.role_changed',
  'user.status_changed',
  'security.code_rotated',
  'security.code_used',
  'user.created',
  'auth.login',
  'auth.logout',
  'auth.refresh_reuse',
  'terminal.registered',
  'data.imported',
  'settings.updated',
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const AuditEntityTypeSchema = z.enum([
  'fight',
  'bet',
  'payout',
  'preset',
  'user',
  'terminal',
  'session',
  'settings',
  'import',
]);
export type AuditEntityType = z.infer<typeof AuditEntityTypeSchema>;

export const AuditEventSchema = z.object({
  id: z.string().length(26),
  orgId: z.string().min(1),
  actorUserId: z.string().nullable(),
  actorRole: RoleSchema.nullable(),
  action: AuditActionSchema,
  entityType: AuditEntityTypeSchema,
  entityId: z.string().nullable(),
  before: z.record(z.unknown()).nullable(),
  after: z.record(z.unknown()).nullable(),
  ip: z.string().max(64).nullable(),
  userAgent: z.string().max(300).nullable(),
  terminalId: z.string().nullable(),
  requestId: z.string().nullable(),
  ts: z.string().datetime({ offset: true }),
});
export type AuditEvent = z.infer<typeof AuditEventSchema>;
